/*
    This file serves as utility function to sit in from of data subscriptions to perform two tasks:
       - Normalize the data structure of information coming from the API layer
       - Reconcile the split nature of the redux store into useful formats
            - [data] - Reconciled from the database state, with any applied changed or deletions represented (Live Data)
            - [updated] - This is only information that has been modified from that of the database state. (Dirty Data)
            - [deleted] - This is any information that has been deleted locally, and not yet applied top the database state

 */


const stateReconciler = {
    array: (state, primaryKey = 'uuid', include = []) => {
        let reconciled = {};

        reconciled.data = [
            ...state.dbState.filter(i => state.updated.find(j => j[primaryKey] === i[primaryKey]) === undefined),
            ...state.updated
        ].filter(v => !state.deleted.includes(v[primaryKey]));

        if (include.includes('updated')) {
            reconciled.updated = state.updated;
        }
        if (include.includes('deleted')) {
            reconciled.deleted = state.deleted;
        }

        return reconciled;
    },
    object: (state, primaryKey = 'uuid', include = []) => {
        let reconciled = {};
        reconciled.data = Object.values({
            ...state.dbState,
            ...state.updated
        }).reduce((agg, v, i) => {
            if (!state.deleted.includes(v[primaryKey])) {
                agg[v[primaryKey]] = v;
            }
            return agg;
        }, {});

        if (include.includes('updated')) {
            reconciled.updated = state.updated;
        }
        if (include.includes('deleted')) {
            reconciled.deleted = state.deleted;
        }

        return reconciled;
    }
};

export default stateReconciler;